import { useGetStatePaymentQuery } from "../store/services/LookUpService"

export default function StatoPagamentoLookup() {
    const {data} = useGetStatePaymentQuery('');
    let optionStatePayment = data?.map((state: string) => ({value: state === 'Qualsiasi' ? '' : state, label: state}))?.filter((op: {value: string, label: string}) => op.label !== 'Qualsiasi')
    return optionStatePayment;
}